const {
  FEATURE_ABILITY_SCORE_IMPROVEMENT_BARD,
  FEATURE_BARD_COLLEGE,
  FEATURE_BARDIC_INSPIRATION,
  FEATURE_COUNTERCHARM,
  FEATURE_EXPERTISE_BARD,
  FEATURE_FONT_OF_INSPIRATION,
  FEATURE_JACK_OF_ALL_TRADES,
  FEATURE_MAGICAL_SECRETS,
  FEATURE_SONG_OF_REST,
  FEATURE_SPELLCASTING_BARD,
  FEATURE_SUPERIOR_INSPIRATION,
} = require('./../../featureIdList')
const {
  SOURCE_PHB,
  SOURCE_SCAG,
  SOURCE_SRD,
} = require('./../../sourceList')
const {fullCasterSpellSlotTable} = require('./../../spellSlotTable')
const {BACKGROUND_ENTERTAINER} = require('./../../backgroundIdList')
const {MAGIC_ITEM_INSTRUMENT_OF_THE_BARDS} = require('./../../magicItemIdList')
const {
  PC_SUBCLASS_BARD_COLLEGE_OF_LORE,
  PC_SUBCLASS_BARD_COLLEGE_OF_VALOR,
} = require('./../../pcSubClassIdList')

const {
  PARAM_CHA,
  PARAM_DEX,
} = require('./../../paramList')

const {
  GEAR_CROSSBOW_HAND,
  GEAR_DAGGER,
  GEAR_DIPLOMAT_S_PACK,
  GEAR_ENTERTAINER_S_PACK,
  GEAR_LEATHER_ARMOR,
  GEAR_LONGSWORD,
  GEAR_LUTE,
  GEAR_RAPIER,
  GEAR_SHORTSWORD,
} = require('./../../gearIdList')

const {
  CAT_LIGHT_ARMOR,
  CAT_MUSIC_TOOLS,
  CAT_SIMPLE_WEAPON,
} = require('./../../gearCategoryList')

const {
  SPELL_CHARM_PERSON,
  SPELL_DANCING_LIGHTS,
  SPELL_DETECT_MAGIC,
  SPELL_HEALING_WORD,
  SPELL_THUNDERWAVE,
  SPELL_VICIOUS_MOCKERY,
} = require('./../../spellIdList')

const {
  PC_CLASS_BARD,
  PC_CLASS_FIGHTER,
  PC_CLASS_WIZARD,
} = require('./../../pcClassIdList')

module.exports = {
  id: PC_CLASS_BARD,
  name: {
    singular: {
      nominative: 'бард',
      genitive: 'барда',
      dative: 'барду',
      accusative: 'барда',
      instrumental: 'бардом',
      prepositional: 'барде',
    },
    plural: {
      nominative: 'барды',
      genitive: 'бардов',
      dative: 'бардам',
      accusative: 'бардов',
      instrumental: 'бардами',
      prepositional: 'бардах',
    },
  },
  nameEn: 'bard',
  description: [
    `Напевая, и перебирая пальцами по старинному монументу, найденному в заброшенных руинах, полуэльфийка в обветшалом [кожаном доспехе](GEAR:${GEAR_LEATHER_ARMOR}) перебирает знания, мелькающие в её голове, вызывая силой магии, заключённой в песне, людей, которые построили этот монумент и загадочное предание, которое он изображает.

Суровый человеческий воин ритмично ударяет своим мечом плашмя о доспех, задавая темп своего военного распева, вдохновляя спутников на отвагу и героизм. Магия его песни укрепляет и подбадривает их.

Смеясь, и настраивая свою цитру, девушка-гном накладывает тонкую магию на собравшихся дворян, гарантируя, что слова её спутников будут хорошо восприняты.

Неважно, кем является бард: учёным, скальдом или проходимцем; он плетёт магию из слов и музыки, вдохновляя союзников, деморализуя противников, манипулируя сознанием, создавая иллюзии, и даже исцеляя раны. `,
    {
      header: `Музыка и магия`,
      text: `В мирах D&D слова и музыка это не просто колебания воздуха, тут они содержат в себе силу. И бард является мастером речей, песен, и волшебства, заложенного в них. Барды говорят, что вся мультивселенная была вызвана к существованию и сформирована словами, которые произнесли боги. И отражения этих первородных Слов Творения до сих пор звучат в космосе. Музыка бардов это попытка уловить эти отзвуки и тонко вплести их в свои заклинания.

Наиболее сильной чертой бардов является их исключительная разносторонность. Многие барды предпочитают держаться не на передовой в бою, используя свою магию для вдохновения союзников и препятствования противникам на расстоянии. Но барды способны защищать себя и в ближнем бою, при необходимости используя магию для укрепления своих клинков и доспехов. Их заклинания чаще предназначены для очарования и создания иллюзий, а не для создания явных разрушений. Они обладают обширными знаниями во множестве тематик и естественные способности, которые позволяют им делать хорошо практически всё. Барды становятся мастерами в тех талантах, к которым стремятся их умы, оттачивая их до совершенства, от музыкальных выступлений до эзотерических знаний.`,
      source: {
        id: SOURCE_PHB,
        page: 52,
      },
    },
    {
      header: `Обучение на опыте`,
      text: `Истинные барды не являются обыденной вещью в мире. Не каждый менестрель, поющий в таверне, или шут, скачущий при королевском дворе, является бардом. Чтобы обнаружить скрытую в музыке магию, требуется тяжёлое обучение и некоторая степень природного таланта, чего большинству трубадуров и жонглёров недостаёт. Однако, определить разницу между этими исполнителями может быть трудно. Жизнь барда проходит в странствиях по землям и посвящена сбору знаний, повествованию историй, и существованию за счёт благодарности публики, как и у любого другого артиста. Но глубина знаний, уровень музыкального мастерства и связь с магией ставит бардов на другую ступень от их собратьев.

Барды редко селятся надолго в одном месте, и их естественная тяга к странствиям связана с поиском новых сказаний, обучением новым навыкам и открытию новых горизонтов, что делает карьеру искателя приключений для них естественным призванием. Каждое приключение — это возможность чему-то научиться, попрактиковать разные навыки, проникнуть в давно заброшенные гробницы, обнаружить утраченные произведения магии, расшифровать старые фолианты, пройтись по незнакомым местам, или столкнуться с экзотическими существами. Барды любят сопровождать героев, чтобы засвидетельствовать их свершения из первых рук. Бард, который может рассказать впечатляющую историю из личного опыта, зарабатывает известность среди других бардов. Более того, после повествования такого большого количества историй о великих свершениях героев, многие барды принимают их близко к сердцу и хотят принять роль героя сами.`,
      source: {
        id: SOURCE_PHB,
        page: 52,
      },
    },
    {
      header: `Барды`,
      text: `Барды в Забытых Королевствах пользуются особым уважением и почётом. Они в своих странствиях доставляют новости, слухи и сообщения, к тому же они — живые кладези истории и фольклора. Барды знают очень много, и как правило, готовы поделиться знаниями или обменять их.

Прибытие известного барда — особенное событие, сродни визиту сановника. Горячий ужин и чистое место ночлега в обмен на пару песен или рассказов — самое меньшее, на что может рассчитывать бард у местного лорда или владельца постоялого двора. Дворянин может обеспечить барду прекрасный приём, при этом одновременно заботясь о том, чтобы никакие домашние тайны дворянина не звучали в песнях и рассказах по всему Фаэруну.

Не все бродячие исполнители — настоящие барды, и не все барды станут петь за ужин, хотя большинство из нужды так и поступит.

На Диком Севере певцы и сказители, называемые скальдами, служат хранителями историй и великих легенд северян и регхедов. Эти воины-поэты исполняют песни и саги, воспламеняющие кровь других воинов, сочиняют новые сказания о великих подвигах героев и злодеев.

Тем не менее, колдовство — табу для Северян и регхедов, если оно не считается даром их богов. Персонажи с классом барда выросшие среди этих народов, скорее всего будут из числа клановых жрецов и шаманов, иначе они рискуют стать изгоями. Большинство скальдов члены [Коллегии доблести](PC_SUBCLASS:${PC_SUBCLASS_BARD_COLLEGE_OF_VALOR}).`,
      source: {
        id: SOURCE_SCAG,
        page: 123,
      },
    },
    {
      header: `Арфисты`,
      text: `Барды на Севере и в Долинах часто могут извлечь выгоду из присутствия там Арфистов — легендарного общества, принимающего в свои ряды бардов и других независимых агентов для борьбы с силами зла. Даже если большинство местных бардов Арфистами и не является (многие попросту не афишируют этот факт), обычный люд Севера зачастую воспринимает всех бардов как легендарных странствующих героев, и, что вполне вероятно, обратятся к нему за помощью в своих местных проблемах, как если бы это был странствующий [воин](PC_CLASS:${PC_CLASS_FIGHTER}) или [волшебник](PC_CLASS:${PC_CLASS_WIZARD}). Такая репутация — это палка о двух концах, и многие враги Арфистов подозрительно относятся даже к самому скромному менестрелю, который может оказаться тайным агентов Арфистов.`,
      source: {
        id: SOURCE_SCAG,
        page: 124,
      },
    },
    {
      header: `Коллегии Бардов`,
      text: `В дополнении к традиции обучения у барда-наставника, на Побережье Меча есть несколько коллегий бардов, где преподаватели учат студентов искусству барда. Они восходят к великим коллегиям бардов далёкого прошлого, зачастую к одному из семи древнейших коллегий: Фоклучан, Мак-Фуирмид, Досс, Канаит, Кли, Анструт и Оламн. Эти семь коллегий считаются создателями [бардовских инструментов](MAGIC_ITEM:${MAGIC_ITEM_INSTRUMENT_OF_THE_BARDS}), каждый из которых назван по имени коллегии.

# Коллегия Фоклучана

Оригинальная Коллегия Фоклучан когда-то стоял на северо-восточном краю Сильверимуна. Через многие годы после закрытия дверей коллегии, он возродился Музыкальная Консерватория Ультрамма. Позже консерваторию перенесли на Южный берег, а на месте древнего коллегии под руководством Мастера-Барда Форелла «Пламеннобородого» Люкуана воздвигли Дом Арфы, стремившийся возродить древние традиции и учения Фоклучан. Годы взращивания традиций и поддержки Сильверимуна, так же, как и Арфистов, сформировали крепкий факультет, способный возродить древний коллегия и Дом Арфы вновь принял имя Фоклучан. Большинство их бардов исследуют и практикуют методы [Коллегии знаний](PC_SUBCLASS:${PC_SUBCLASS_BARD_COLLEGE_OF_LORE}).

Коллегия Фоклучана естественным образом союзничает с Арфистами, хотя её руководство всегда подчеркивает, что цели у них разные.

# Коллегия Нового Оламна

Раскинувшийся на двух виллах по Тропе Утёса близ Глубоководья, Коллегия Новый Оламн — престижная коллегия бардов основанная состоятельными глубоководскими господами в Год Посоха (1366 ЛД) и названная в честь старой Коллегии Оламн. Студенты коллеги проходят обучение с выбранным ими инструментом, наряду тщательным изучением и запоминанием древних песен, саг и истории. Большинство бардов Нового Оламна принадлежат [Коллегии знаний](PC_SUBCLASS:${PC_SUBCLASS_BARD_COLLEGE_OF_LORE}).

Тропа Утеса — гравийная дорога, проходящая по северным отрогам горы Глубоководье, используемая для доставки в коллегия припасов, но большинство посетителей и студентов пользуются Проходом Горной Мелодии, туннелем сквозь саму гору. В туннеле постоянно звучит музыка благодаря Бесконечной Нити Жемчуга — бесконечному концерту, устраиваемому студентами бардами в небольшом алькове в пещере, которая сохраняет и повторяет музыку.

Давным-давно, барды, стремящиеся получить статус мастера-барда посещали все древние коллегии, чтобы постичь их музыкальные и магические секреты. По традиции коллегии посещались в порядке, указанном выше, начиная с Фоклучан. Когда коллегии пришли в упадок, традиция умерла, но некоторые барды мечтаю о её восстановлении.

# Коллегия Герольдов

Располагающаяся в великом доме знаний Крепость Герольдов на северо-западе Сильверимуна, Коллегия Герольдов посвящена сохранению легенд и древней истории. Герольды собирают и систематизируют знания, которые они делают доступными для всех имеющих добрые и мирные намерения. Основанные арфистом Алиостом Осткруннаром в 992 ЛД, Герольды являются союзниками Арфистов, но предпочитают сохранять нейтралитет в большинстве конфликтов, во главу угла ставя именно сохранение знаний.

Коллегия Герольдов менее заботится об умении играть на музыкальных инструментах (хотя и имеют обширную библиотеку песен) и делает больший упор на историю, геральдику и фольклор, что делает её ключевым центром обучения бардов [Коллегии знаний](PC_SUBCLASS:${PC_SUBCLASS_BARD_COLLEGE_OF_LORE}).`,
      source: {
        id: SOURCE_SCAG,
        page: 124,
      },
    },
    {
      header: `Лунные звёзды`,
      text: `Более века назад среди Арфистов произошел раскол. Келбен «Чёрный Посох» Арунсан был осужден остальными лидерами Арфистов за увеличение силы и расширение влияния Фзула Чембрила, злого лидера Жентарима, с помощью могущественного артефакта. То, что Келбен сделал это, чтобы Фзул смог уничтожить могущественного лича, большого значения при этом не имело. Келбен и Лаэраль Сильверхэнд, его жена, покинули Арфистов забрав с собой некоторых их агентов и создали новую организацию, над созданием которой Келбен некоторое время тайно работал, зная о древнем пророчестве эльфов Кормантора. Эта группа назвалась Лунными звёздами, что на эльфийском звучит как _Тель’Теукиира_. И хотя Арфисты и Лунные звёзды временами работали в тандеме, их цели бывали противоположными, и кроме того, в Лунных звёздах состояли такие личности, которых Арфисты посчитали бы слишком злыми, как, например, вампиры. Лунные звёзды совершили много добрых дел, но их методы зачастую более жестокие и прагматичные, чем позволяют идеалы Арфистов. После смерти Келбена Лунные звёзды, казалось, развалились, и в течение многих лет организация считалась несуществующей. Тем не менее во время Раскола ждавшие своего часа агенты развернули организацию удивительно большого масштаба, члены которой оказались в Кэндлкипе, Глубоководье и Миф Дранноре. Затем организация вновь ушла в подполье. Отношения организации с нынешними Арфистами (Лаэраль Сильверхэнд и нынешней «Черным Посохом Глубоководья» Важрой) остаются не ясными.`,
      source: {
        id: SOURCE_SCAG,
        page: 125,
      },
    },
    {
      header: `Создание барда`,
      text: `Барды процветают за счет историй, не важно, правдивы они или нет. Ваша предыстория и мотивы не так важны, как истории, что Ваш персонаж рассказывает о себе. Возможно, у Вас было безопасное и ничем не примечательное детство. В нём нет хороших историй, чтобы поведать о них, но Вы можете изобразить себя сиротой, воспитанным ведьмой на зловещем болоте. Или Ваше детство действительно может быть достойным истории. Некоторые барды приобретают свою волшебную музыку необычайными способами, в том числе под влиянием фей или других сверхъестественных существ.

Были ли Вы учеником у мастера, следуя за более опытным бардом, пока не начали следовать своему собственному пути? Или посещали коллегию, где Вы обучались знаниям бардов и практиковали свою музыкальную магию? Может быть, Вы в молодости сбежали из дома, или став сиротой подружились с бродячим бардом, который стал вашим наставником. Или Вы могли быть избалованным знатным ребенком, обученным мастером. 

Может быть, Вы попали в лапы ведьмы, совершив сделку, посулившую Вам музыкальный дар вдобавок к Вашей жизни и свободе, но какой ценой?`,
      source: {
        id: SOURCE_PHB,
        page: 53,
      },
    },
    {
      header: `Быстрое создание`,
      text: `Вы можете быстро создать барда, следуя этим рекомендациям.

1. Во-первых, у Вашей Харизмы должно быть наивысшее значение. Следующей по величине характеристикой должна быть Ловкость.
2. Во-вторых, выберите предысторию «[Артист](BACKGROUND:${BACKGROUND_ENTERTAINER})».
3. В-третьих, получите заговоры [Злая насмешка](SPELL:${SPELL_VICIOUS_MOCKERY}) и [Пляшущие огоньки](SPELL:${SPELL_DANCING_LIGHTS}) вместе со следующими заклинаниями 1 уровня: [Волна грома](SPELL:${SPELL_THUNDERWAVE}), [Лечащее слово](SPELL:${SPELL_HEALING_WORD}), [Обнаружение магии](SPELL:${SPELL_DETECT_MAGIC}) и [Очарование личности](SPELL:${SPELL_CHARM_PERSON}).`,
      source: {
        id: SOURCE_PHB,
        page: 53,
      },
    },
  ],
  note: [
    {
      text: `Музыка — это плод божественного древа, которое вибрирует Словами Созидания. Но вопрос, который я хочу вам задать, может ли бард спуститься к корням этого древа? Может ли кто-то прикоснуться к источнику этой силы? Ах, какую бы музыку это принесло в мир!`,
      author: `Флетчер Данайриа, мастер бард`,
    },
    {
      text: `Музыка — это тупо. Стой. Я передумал. Музыка — это весело. Сыграй ещё. Нет, в первый раз я был прав. Музыка — это тупо. Но я всё=таки тебя не покалечу, если ещё раз передумаю`,
      author: `Занатар`,
    },
  ],
  featureCollection: {
    hitDice: 8,
    proficiency: {
      armor: [
        CAT_LIGHT_ARMOR,
      ],
      weapon: {
        catList: [
          CAT_SIMPLE_WEAPON,
        ],
        gearList: [
          GEAR_CROSSBOW_HAND,
          GEAR_LONGSWORD,
          GEAR_RAPIER,
          GEAR_SHORTSWORD,
        ],
      },
      tool: {
        toChoose: {
          count: 3,
          limitCatList: [
            CAT_MUSIC_TOOLS,
          ],
        },
      },
      savingThrow: [
        PARAM_CHA,
        PARAM_DEX,
      ],
      skill: {
        toChoose: {
          count: 3,
        },
      },
    },
    equipment: {
      coins: {
        diceCount: 5,
        diceType: 4,
        times: 10,
      },
      text: `
1. Выберите одно
    * а) [Рапира](GEAR:${GEAR_RAPIER})
    * б) [Длинный меч](GEAR:${GEAR_LONGSWORD})
    * в) Любое простое оружие
2. Выберите одно
    * а) [Набор дипломата](GEAR:${GEAR_DIPLOMAT_S_PACK})
    * б) [Набор артиста](GEAR:${GEAR_ENTERTAINER_S_PACK})
3. Выберите одно
    * а) [Лютня](GEAR:${GEAR_LUTE})
    * б) Любой другой музыкальный инструмент
4. [Кожаный доспех](GEAR:${GEAR_LEATHER_ARMOR})
5. [Кинжал](GEAR:${GEAR_DAGGER})`,
    },
  },
  progressTable: `
| Уровень | Умения                                               | Заговоры | Заклинания | 
|---------|------------------------------------------------------|----------|------------| 
|  1      | [Использование заклинаний](FEATURE:${FEATURE_SPELLCASTING_BARD}), [Вдохновение барда](FEATURE:${FEATURE_BARDIC_INSPIRATION}) (к6) | 2 | 4 |  
|  2      | [Мастер на все руки](FEATURE:${FEATURE_JACK_OF_ALL_TRADES}), [Песнь отдыха](FEATURE:${FEATURE_SONG_OF_REST}) (к6) | 2 | 5 |  
|  3      | [Коллегия бардов](FEATURE:${FEATURE_BARD_COLLEGE}), [Компетентность](FEATURE:${FEATURE_EXPERTISE_BARD}) | 2 | 6 |  
|  4      | [Увеличение характеристик](FEATURE:${FEATURE_ABILITY_SCORE_IMPROVEMENT_BARD})              | 3 | 7 |  
|  5      | Вдохновение барда (к8), [Источник вдохновения](FEATURE:${FEATURE_FONT_OF_INSPIRATION})     | 3 | 8 |  
|  6      | [Контрочарование](FEATURE:${FEATURE_COUNTERCHARM}), Умение коллегии бардов                 | 3 | 9 |  
|  7      | —                                                    | 3        | 10         |  
|  8      | Увеличение характеристик                             | 3        | 11         |  
|  9      | Песнь отдыха (к8)                                    | 3        | 12         |  
| 10      | Вдохновение барда (к10), Компетентность, [Тайны магии](FEATURE:${FEATURE_MAGICAL_SECRETS}) | 4 | 14 |  
| 11      | —                                                    | 4        | 15         |  
| 12      | Увеличение характеристик                             | 4        | 15         |  
| 13      | Песнь отдыха (к10)                                   | 4        | 16         |  
| 14      | Тайны магии, Умение коллегии бардов                  | 4        | 18         |  
| 15      | Вдохновение барда (к12)                              | 4        | 19         |  
| 16      | Увеличение характеристик                             | 4        | 19         |  
| 17      | Песнь отдыха (к12)                                   | 4        | 20         |  
| 18      | Тайны магии                                          | 4        | 22         |  
| 19      | Увеличение характеристик                             | 4        | 22         |  
| 20      | [Превосходное вдохновение](FEATURE:${FEATURE_SUPERIOR_INSPIRATION}) | 4 | 22 |
`,
  spellSlotTable: fullCasterSpellSlotTable,
  source: [
    {
      id: SOURCE_PHB,
      page: 52,
    },
    {
      id: SOURCE_SRD,
      page: 11,
    },
  ],
}
